import { makeAutoObservable } from "mobx";

export interface StudentRequestApi {
  name: string;
  password: string | null;
  studentId: string;
}

export class ObservableStudentPropImpl {
  name: string;
  password: string | null;
  studentId: string;

  constructor(student: StudentRequestApi) {
    this.name = student.name;
    this.password = student.password;
    this.studentId = student.studentId;
    makeAutoObservable(this);
  }

  onChangeName = (name: string) => {
    this.name = name;
  };
  onChangePassword(password: string) {
    this.password = password;
  }
  onChangeId(id: string) {
    this.studentId = id;
  }
}
